import { gql } from '@apollo/client'

export const ANONYMOUS_TOKEN = gql`
  query {
    anonymousToken
  }
`
